<template>
  <div class="tx-Taxons_Wrapper">
    <div class="h6 tx-Taxons_Header tx-Taxons_HeaderText mt-0">{{ title }}</div>
    <taxon-item
      :key="`taxon-item-${index}`"
      v-for="(item, index) in visibleItems"
      v-bind="item"
    ></taxon-item>
    <button
      v-if="hasManyItems"
      @click="isExpanded = !isExpanded"
      class="btn btn-sm btn-primary-link ml-n1 mt-1"
    >
      {{ isExpanded ? t.show_less : t.show_more }}
    </button>
  </div>
</template>

<script>
import TaxonItem from "./TaxonItem";
export default {
  name: "TaxonGroup",
  components: {
    TaxonItem,
  },
  props: {
    items: {
      required: true,
      type: Array,
    },
    t: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    maxVisible: {
      required: false,
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      isExpanded: false,
      hasManyItems: this.items.length > this.maxVisible,
    };
  },
  computed: {
    visibleItems() {
      return this.items.slice(0, this.isExpanded ? this.items.length : this.maxVisible);
    },
  },
};
</script>
